import { render, staticRenderFns } from "./OneTariff.vue?vue&type=template&id=756f43fa&scoped=true&"
import script from "./OneTariff.vue?vue&type=script&lang=js&"
export * from "./OneTariff.vue?vue&type=script&lang=js&"
import style0 from "./OneTariff.vue?vue&type=style&index=0&id=756f43fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f43fa",
  null
  
)

export default component.exports